import { render } from "./App.vue?vue&type=template&id=1735b41a"
const script = {}

import exportComponent from "/codebuild/output/src2943782866/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__